import React from 'react';
import { Link } from 'react-router-dom';
import { MinusIcon, PlusIcon, Trash2Icon } from 'lucide-react';
import type { CartItem } from '../../types/product';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
export function CartLineItem({
  item,
  size = 'sm',
  onNavigate
}: {
  item: CartItem;
  size?: 'sm' | 'lg';
  onNavigate?: () => void;
}) {
  const {
    setQty,
    removeItem
  } = useCart();
  const {
    product,
    qty,
    unitPrice,
    image,
    options,
    key
  } = item;
  const imgSize = size === 'lg' ? 'h-24 w-24 sm:h-28 sm:w-28' : 'h-20 w-20';
  return <li className="flex gap-4 py-4" data-id="element-43" data-mp="2a5efj9d2jay">
      <Link to={`/product/${product.id}`} onClick={onNavigate} className="shrink-0" data-id="element-44" data-mp="2b6nji6tgvq1">
        <img src={image} alt="" className={`${imgSize} rounded-lg bg-surface object-cover`} data-id="element-45" data-mp="3tiatsav50dxe" />
      </Link>
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-46" data-mp="3ogljwyjni6aw">
        <div className="flex items-start justify-between gap-2" data-id="element-47" data-mp="3kgjq1bk5qh66">
          <div className="min-w-0" data-id="element-48" data-mp="3kiec4t760fbu">
            <p className="text-xs text-muted" data-id="element-49" data-mp="2d4g4fzh96gwv">{product.brand}</p>
            <Link to={`/product/${product.id}`} onClick={onNavigate} className="line-clamp-2 text-sm font-semibold leading-snug text-ink hover:underline" data-id="element-50" data-mp="2d23hf7wn1gcy">
              {product.name}
            </Link>
            {options.length > 0 && <p className="mt-0.5 line-clamp-2 text-xs text-muted" data-id="element-51" data-mp="285mq64u56lvn">{options.join(' · ')}</p>}
          </div>
          <button type="button" onClick={() => removeItem(key)} aria-label={`${product.name} verwijderen`} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-muted hover:bg-surface hover:text-sale" data-id="element-52" data-mp="2vvh2mlaju8fd">
            <Trash2Icon className="h-4 w-4" data-id="element-53" data-mp="2qu04gxjg902h" />
          </button>
        </div>
        <div className="mt-auto flex items-center justify-between pt-2" data-id="element-54" data-mp="1beksa6wbhsz9">
          <div className="flex items-center rounded-lg border border-line" data-id="element-55" data-mp="1fg64rr4xw58x">
            <button type="button" onClick={() => setQty(key, qty - 1)} aria-label="Aantal verlagen" className="flex h-8 w-8 items-center justify-center text-ink hover:bg-surface" data-id="element-56" data-mp="1fe33uc290rpf">
              <MinusIcon className="h-3.5 w-3.5" data-id="element-57" data-mp="38c8dxkynnm2x" />
            </button>
            <span className="w-7 text-center text-sm font-semibold tabular-nums text-ink" data-id="element-58" data-mp="33egkunm9xtx5">{qty}</span>
            <button type="button" onClick={() => setQty(key, qty + 1)} aria-label="Aantal verhogen" className="flex h-8 w-8 items-center justify-center text-ink hover:bg-surface" data-id="element-59" data-mp="2zcbxu7qbzvjh">
              <PlusIcon className="h-3.5 w-3.5" data-id="element-60" data-mp="2pexo0qywy505" />
            </button>
          </div>
          <span className="text-sm font-bold text-ink" data-id="element-61" data-mp="2kgmfqko9o2k1">{formatPrice(unitPrice * qty)}</span>
        </div>
      </div>
    </li>;
}